import { net_filemanage } from "@/api/http";
export const API_STFMFM02C27_UpdatePropert = (...params) =>
net_filemanage.post("/api/STFMFM02C27/UpdatePropert", ...params)